module.exports = __webpack_public_path__ + "static/media/YB5M08_2.4f2c4cb4.jpg";